package one.healthium.paywall.ui

sealed interface PaywallEvent {
    data object PaywallPassed : PaywallEvent
}